import React from 'react'

import classNames from 'clsx'

import { Divider, ListSubheader } from '@mui/material'

import { SCOPING_PROPS } from '~/src/Journal/constants'
import { shape as roomShape } from '~/src/Room/bundle'

const HeaderComponent = ({ classes, ...props }) => {
  const scopeProp = SCOPING_PROPS.find(key => props[key])
  const { [scopeProp]: scope } = props

  return (
    scope ? (
      <>
        <ListSubheader component="div" classes={{ root: classNames(classes.card, classes.subheader) }}>
          {`Journal for ${scope.fullName ?? scope.name}`}
        </ListSubheader>
        <Divider />
      </>
    ) : null
  )
}
HeaderComponent.propTypes = {
  scope: roomShape,
}
HeaderComponent.defaultProps = {
  scope: null,
}
HeaderComponent.displayName = 'Journal/Header'

export default React.memo(HeaderComponent)
